import React from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import { logout  } from '../../store/auth'
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  spacing: {
    marginBottom: '12px' 
  },
  userInput: {
    width: '80%',
    backgroundColor: 'white',
  },
  userButtons: {
    width: '80%',
    marginTop: '5px'
  }
}));

const Logout = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <Grid container style={{marginTop: '15%'}} justify="center">
      <Grid container style={{minWidth: '30vmax', maxWidth: '30vmax', padding: '10px 10px 10px 10px', border: '2px solid gray', borderRadius: '15px'}}>
        <Grid container justify="center">
          <Grid container item lg={2} xs={4} justify="center" className={classes.userButtons}>
            <Button variant="contained" size="small" onClick={handleLogout}>Logout</Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Logout